import { z } from 'zod';

import { type RealTimeEligibilityResultSchema } from './resultSchema.js';
import type { BaseFlowBlock, BlockType } from '../base/baseSchema.js';

export const RealTimeEligibilityBlockSchema = z.object({
  patientInsuranceInformationId: z.string(),
  npi: z.string(),
});

export type RealTimeEligibilityBlockConfig = z.infer<typeof RealTimeEligibilityBlockSchema>;

export interface RealTimeEligibilityBlock extends BaseFlowBlock {
  type: BlockType.RealTimeEligibility;
  config: RealTimeEligibilityBlockConfig;
}

export type RealTimeEligibilityResult = z.infer<typeof RealTimeEligibilityResultSchema>;
